import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const en = {
  /** In use. Please move it carefully. */
  IBCorporate: 'IB Corporate',
  IBIndividual: 'IB Individual',
  MAMIndividual: 'MAM Individual',
  MAMMasterWithLPOA: 'MAM Individual',
  MarkupConfirmation: 'Markup Confirmation',
  UserCorporate: 'User Corporate',
  UserIndividual: 'User Individual',
  UserJoint: 'User Joint',
  account: {
    bankingDetails: 'Banking Details',
    createANewAccount: 'Create a new account',
    register: 'Register',
    registerSignInTitle: 'Already a Member?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },

  adminSocialTrading: {
    title: 'Social Trading',
    investorAccountDetails: {
      tradingAccountName: 'Trading Account Name',
      balance: 'Balance',
      login: 'Login',
    },
    masterAccountDetails: {
      copyType: 'Copy Type',
      groupMappingType: 'Group Mapping Type',
      login: 'Login',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Collect your Birthday gift',
    availableTable: {
      bonusSize: 'Bonus Size',
    },
  },
  /** In use. Please move it carefully. */
  errors: {
    shared: {
      recordWasNotFound: 'Record was not found',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Captcha server is unavailable. Please refresh the page and try again. If the problem remains please contact support via online chat or by email {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Please note, that the max limit for profit sharing has been exceeded. The max limit is {{0}}%.',
      notEnoughMoney:
        'We apologize, but you do not have enough funds in your trading account to process the requested withdrawal. Please ensure that you have a sufficient balance available before attempting a withdrawal. Please note that in addition to the available balance, you should also consider the free margin level required for withdrawals.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'The Master account is ineligible to be copied at this time, please try again later.',
    },
    securityCode: {
      emptyValue: 'The entered security value (password or PIN code) cannot be empty or null',
      invalidLength: 'The entered security value (password or PIN code) must contain {{0}} character(s)',
      invalidMinLength: 'The entered security value (password or PIN code) must contain at least {{0}} character(s)',
      invalidMaxLength: 'The entered security value (password or PIN code) must not exceed {{0}} character(s)',
      manyRepeatedValues:
        'The entered security value (password or PIN code) must not have more than {{0}} repeated character(s)',
      missingNumericValues: 'The entered security value (password or PIN code) must contain numeric character(s)',
      containsNumericValues: 'The entered security value (password or PIN code) must not contain any numeric values',
      missingLowerCaseValues: 'The entered security value (password or PIN code) must contain lowercase character(s)',
      containsLowerCaseValues:
        'The entered security value (password or PIN code) must not contain any lowercase values',
      missingUpperCaseValues: 'The entered security value (password or PIN code) must contain uppercase character(s)',
      containsUpperCaseValues:
        'The entered security value (password or PIN code) must not contain any uppercase values',
      missingSpecialValues: 'The entered security value (password or PIN code) must contain special character(s)',
      containsSpecialValues:
        'The entered security value (password or PIN code) must not contain any special characters',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Sorry for the inconvenience, but the account {{0}} has been disabled',
      ageIsAboveMaxAllowed: 'We do not accept applications from anyone under {{0}} or over {{1}} years old.',
      ageIsUnderMinAllowed: 'We do not accept applications from anyone under {{0}} years old.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "The IB code '{{0}}' is incorrect. Please enter a valid IB code",
      invalidCredentials: 'Invalid username {{0}} and/or password',
      invalidLengthOfPhoneNumber: 'The phone number length is invalid, please try again',
      invalidLink: 'The link is invalid',
      invalidPhoneNumberLength: 'The phone number length is invalid, please try again',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: "User {{0}} doesn't exist",
      userEmailAlreadyExists: 'User email has been already registered in the system',
      userPhoneAlreadyExists: 'User phone has been already registered in the system',
      cantUpdateProfileActualStatus: "Can't update account {{0}}, actual status = {{1}}",
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'or drag here your files',
    exportFormat: 'Export Format',
    getCode: 'Get Code',
    hide: 'Hide',
    limitMessage: '{{limit}} Characters left',
    resend: 'Resend',
    seconds: 'sec',
    show: 'Show',
  },
  headerWithBalance: {
    serverTime: 'Server Time',
    failedToFetchServerTime: 'Failed to fetch server time',
    view: 'View',
  },
  investors: {
    blackList: 'Black List',
  },
  legal: {
    clientAgreement: 'Client Agreement',
    privacyPolicy: 'Privacy Policy',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'About Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Master Nickname',
      rating: 'Position in Rating',
    },
  },
  menu: {
    deposit: 'Deposit',
  },
  messages: {
    /** In use. Please move it carefully. */
    CopyTrading: {
      InvestorAccountWasLinked: "Follower account started to copy Master account '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Follower account was created. Follower account started to copy Master account '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "Follower account stopped to copy Master account '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Master account was modified. (Profit sharing={{ProfitSharing}}, Allocation method={{AllocationMethod}})',
      MasterAccountWasLinked: "Follower's account '{{InvestorAccountName}}' started to copy Master account.",
      MasterAccountWasOpened:
        'Master account was created. (Profit sharing={{ProfitSharing}}, Allocation method={{AllocationMethod}})',
      MasterAccountWasUnlinked: "Follower's account '{{InvestorAccountName}}' stopped to copy Master account.",
    },
  },
  modal: {
    error: 'Error',
    notification: 'Notification',
    ok: 'Ok',
  },
  operationHistory: {
    filterName: 'Search',
    placeholder: 'Please enter',
  },

  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Sales',
    ibInfo: {
      detailsTitle: 'IB Details',
      nextRebatePayment: 'Next Rebate Payment',
      statistics: {
        closetTradersReport: {
          type: 'Type',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'Markups are incorrect! Please contact our support team to get correct markups',
    },
    salesUserInfo: {
      aeCode: 'AE Code',
    },
  },
  profile: {
    adult: 'I am over 18 years old',
    code: 'Code',
    country: 'Country',
    documentsUploaded: 'Uploaded Documents',
    isAgreeWithTermsAndConditions: 'I accept the <0>Client Agreement</0> and the <1>Privacy Policy</1>',
    pleaseValidateAccountToDeposit:
      'Your personal details require verification by the {{brokerName}} compliance team. Before proceeding to deposit, you need to submit a scan of your ID',
    successChangeDescription: 'Changes are saved!',
    warningMessage: {
      profileIsBeingVerified: 'Your profile is being verified, it might take a couple of seconds',
    },
  },
  psp: {
    accountsFetchFailErr: 'Failed to fetch accounts',
    confirmEveryTransaction: 'Confirming all transactions, deposits can take up to 24 hours',
    deposit: {
      depositForm: {
        accountNameTitle: 'Account Name',
        addressLine2: 'Address Line 2',
        beneficiaryAccountNumberTitle: 'Beneficiary Account Number',
        beneficiaryBankHint: 'Please select the bank account number',
        beneficiaryBankNameHint: 'Bank Name, e.g. (Standard Charted Bank)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Please attach a document confirming payment if needed',
      },
      depositTitle: 'Deposit Funds',
      notice: 'Deposits are available only for verified accounts',
      warnToSubmitPersonalDetails:
        'To make a deposit, please submit your personal details. Please make sure they match the data in your ID',
    },
    localAgentTable: {
      login: 'Login',
    },
    operationsFetchFailErr: 'Failed to fetch operations',
    operationsTable: {
      documentTitle: 'Document',
      operationsTableTitle: 'Recent Operations',
      paymentSystemTitle: 'Payment System',
    },
    pluginInfoFetchFailErr: 'Failed to fetch plugin info',
    pluginNotFound: 'Plugin not found',
    pluginsFetchFailErr: 'Failed to fetch plugins',
    preAuthorizedBanking: 'Pre-Authorized Banking',
    qrCodeCryptoNotice:
      'The QR Code is for one-time use only. Do not scan this code in a Crypto application more than once, otherwise your payment will be suspended.',
    qrCodeCryptoTitle: 'QR Code for Crypto application',
    resentOperationsTitle: 'Recent Operations',
    transfer: {
      transactionDetailsTitle: 'Transaction details',
      transferForm: {
        amountError: 'Available transfer amount was exceeded',
        currencyTitle: 'Currency',
      },
    },
    uploadBankStatementWithBankName:
      'Upload a bank statement which contains Bank Name, your Full Name and Bank Account Number',
    uploadPayslip: 'Upload the bank payslip of your deposit',
    uploadYourDocument: 'Please confirm your deposit by uploading your bank statement',
    withdrawal: {
      notice: 'Withdrawals are available only for verified accounts',
      withdrawalTitle: 'Withdraw Funds',
      withdrawalForm: {
        bankNameTitle: 'Bank Name',
        beneficiaryCryptoWalletHint: 'A wallet number with cryptocurrency money will be sent to',
        beneficiaryCryptoWalletTitle: 'Beneficiary Crypto Wallet',
        confirmTitle: 'Confirm withdraw information',
      },
    },
  },

  settings: {
    docsForm: {
      documentNumberHint: 'Check if Identification number is the same as on the photo',
      documentTypeHint: 'Please make sure you provide a high quality photo or scan of valid document',
      uploadedDocumentsTable: {
        docNameTitle: 'Document Name',
        documentNumber: 'Document number',
        typeTitle: 'Document Type',
      },
    },
    profileForm: {
      editProfileTitle: 'Edit profile',
      proceedToDeposit: 'Proceed to Deposit',
      saveUserSuccessMessage: 'Profile was successfully saved',
      userDetailsErrorMessage: 'Failed to fetch user profile',
      verifyPersonalDetails: 'Verify Personal Details',
      verifyProfileBtn: 'Verify Profile',
    },
  },
  socialTradingModal: {
    copyHint: 'Your Account {{account}} will stop to copy Master {{oldMaster}}, and start to copy {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Trading Account',
    accountHistoryForm: {
      closeTimeTitle: 'Close Time',
    },
    changeTradingAccountName: 'Change trading account name',
    connectedAccounts: 'Connected Accounts',
    currency: 'Currency',
    depositForm: {
      amountTitle: 'Amount',
      errorMessage: 'Failed to deposit funds',
      successMessage: 'Deposit was successfully made',
    },

    descriptionPlaceholder: 'Enter recommendation for you followers',
    fetchServersErr: 'Failed to fetch servers',

    ibCode: 'IB (optional)',
    notRows: 'No rows to display',
    openAccountModalSubTitle: 'The widest range of trading instruments: currencies, metals. Standard trading terms.',
    tradingPlatforms: 'Trading Platforms',
    transferForm: {
      title: 'Transfer Funds',
    },
    withdrawForm: {
      amountTitle: 'Amount',
      errorMessage: 'Failed to save leverage',
      successMessage: 'Withdrawal was successfully made',
    },
  },
} satisfies ILocaleLegacy;
